// const URL = "http://localhost:5000";
// const URL= 'https://aabuild.escaff.uk';
const URL = "https://oldone.sdlpro.management/";

export default URL;
